import { Help } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

interface PropTypes {
    href: string;
}

export const HelpLink: React.FC<PropTypes> = ({ href }): JSX.Element => (
    <Tooltip title="Click to open tooling documentation">
        <IconButton
            aria-label="documentation"
            color="primary"
            component="a"
            href={href}
            size="small"
            target="_blank"
        >
            <Help fontSize="small" />
        </IconButton>
    </Tooltip>
);
